import { LogoImage } from "customizations";
import { User } from "api";
import { withErrorBoundary,  Spinner,  GoogleStaticMap,  Formatter,  Modal} from "shared";
import { SmartButtonStub, SmartButtonLink } from "ui/smart-buttons";
import "react-phone-number-input/style.css";
import Input from "react-phone-number-input/input";
import GuestSignupForm from "./GuestSignupForm";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { parsePhoneNumberFromString } from 'libphonenumber-js'

class LoginPage extends Component {
  state = { settings: {}, userforgotPasswordLink: "", email: "", password: "", homeAddress: "", phoneNumber: "", showRegisterHomeForm: false, showSignUpForm: false, signupPhone: "", signupAddress: "", showLoginForm: false, loginError: null, verificationError: null, homeLat: null, homeLng: null, activeForm: "registerHome", signInBannerFrame: null, signInBannerNatural: null };

  constructor(props) {
    super(props);
    this.signInBannerFrameRef = React.createRef();
  }

  signupSettings() {
    return this.props.prefetchedSignupSettings != null
      ? this.props.prefetchedSignupSettings
      : this.state.settings;
  }

  async componentDidMount() {
    window.addEventListener("resize", this.updateSignInBannerFrame);

    if (this.props.prefetchedSignupSettings != null) return;
    try {
      const settings = await Backend.get("/signup_settings");
      this.setState({ settings });
    } catch (err) {
      console.error("Failed to load signup settings:", err);
    }

    const applyGooglePlacesAccessibilityFix = () => {
      const input = document.querySelector("#react-google-places-autocomplete-input");
      if (input) {
        input.setAttribute("autocomplete", "street-address");
        input.setAttribute("id", "home-address");
        input.setAttribute("name", "street-address");
        input.setAttribute("aria-label", "Street Address");
        input.style.border = "2px solid #2C2C2C";
        input.style.borderRadius = "4px";
        input.style.color = "#000000";
        input.style.backgroundColor = "#FFFFFF";
        input.style.padding = "0.5rem";
      }
    };

    setTimeout(applyGooglePlacesAccessibilityFix, 100);
  }

  renderSignInPageBanner() {
    const url = this.signupSettings()?.sign_in_page_banner;
    if (!url) return null;

    return (
      <img
        className="login-modal-banner-media"
        src={url}
        alt=""
      />
    );
  }

  render() {
    return (
      <div className="LoginModal">
        <div className="top d-block position-relative overflow-hidden" ref={this.signInBannerFrameRef}>
          {this.renderSignInPageBanner()}
          <div className="top-overlay"></div>
        </div>
        <div className="bottom">{this.renderRightPane()}</div>
      </div>
    );
  }

  renderRightPane() {
    const settings = this.signupSettings();
    return (
      <>
        <div className="text-center mb-4">
          {!settings.hide_home && (
            <SmartButtonStub
              text="Register Your Home"
              buttonType="button"
              className="primary custom-font-size custom-font-family mb-1 mb-md-0"
              click={() =>
                this.setState({
                  verificationError: null,
                  showSignUpForm: false,
                  signupSuccess: false,
                  userForgotPasswordLink: "",
                  activeForm: "registerHome",
                  showRegisterHomeForm: !this.state.showRegisterHomeForm,
                  loginError: null,
                })
              }
            />
          )}
          <SmartButtonStub
            text="Register as a Guest"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            buttonType="button"
            click={() =>
              this.setState({
                verificationError: null,
                userForgotPasswordLink: "",
                signupSuccess: false,
                activeForm: "signUp",
                showSignUpForm: !this.state.showSignUpForm,
              })
            }
          />

          <SmartButtonStub
            text="Sign In"
            buttonType="button"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            click={() =>
              this.setState({
                verificationError: null,
                userForgotPasswordLink: "",
                activeForm: "login",
                signupSuccess: false,
                showLoginForm: !this.state.showLoginForm,
              })
            }
          />
        </div>

        {this.state.activeForm === "registerHome" &&
          this.renderRegisterHomeForm()}
        {this.state.activeForm === "signUp" && (
          <div className="px-4 mt-3">
            <GuestSignupForm
              onSuccess={() => this.setState({ signupSuccess: true, activeForm: 'login' })}
            />
          </div>
        )}
        { this.state.signupSuccess && <p className="alert alert-success text-center">
            {App.isBigSky
              ? "Thank you for registering! Please check your email for additional welcome information and credentials."
              : "Thank you for registering! Please Sign In to activate your account."}
          </p>
        }
        {this.state.activeForm === "login" && this.renderSignInForm()}
      </>
    );
  }

  renderSignInForm() {
    return (
      <div className="px-4 mt-3 custom-text-community">
        
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 px-4">
           {this.state.loginError && (
              <p className="alert alert-danger mt-2" style={{ fontSize: '17px' }}>
                {this.state.loginError}
              </p>
            )}
            {this.state.userForgotPasswordLink && (
              <p className="alert alert-info mt-2 text-center" style={{ fontSize: '17px' }}>
                <a href="/u/password/new" target="_blank" rel="noopener noreferrer">
                  Click here to reset your password
                </a>
              </p>
            )}
          </div>
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={this.state.email}
            onChange={this.inputChanged}
            id="email"
            aria-label="Email address"
            autocomplete="email"
            style={{
              border: "2px solid #2C2C2C",
              borderRadius: "4px",
              color: "#000000",
              backgroundColor: "#FFFFFF",
              padding: "0.5rem"
            }}
          />
        </div>

        <div className="form-group mt-2">
          <label>Password</label>
          <input
            type="password"
            name="password"
            className="form-control"
            value={this.state.password}
            onChange={this.inputChanged}
            id="password"
            aria-label="Password"
            autocomplete="new-password"
            style={{
              border: "2px solid #2C2C2C",
              borderRadius: "4px",
              color: "#000000",
              backgroundColor: "#FFFFFF",
              padding: "0.5rem"
            }}
          />
        </div>

        <div className="mt-3 d-flex justify-content-end">
          <SmartButtonStub
            text="Request Account Deletion"
            buttonType="button"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            click={() => window.location.href = "/u/account-deletion"} 
          />
          <SmartButtonStub
            text="Login"
            buttonType="button"
            className="primary custom-font-size custom-font-family mb-1 mb-md-0"
            click={this.logIn}
          />
        </div>
      </div>
    );
  }

  renderRegisterHomeForm() {
    const { showSignUpForm, verificationError, homeAddress, phoneNumber, homeLat, homeLng, signupAddress, signupPhone, userforgotPasswordLink } = this.state;

    if (!showSignUpForm) {
      return (
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 px-4">
              {verificationError && (
                <p className="alert alert-danger mt-2 text-center">
                  {verificationError}
                </p>
              )}

              {userforgotPasswordLink && (
                <p className="alert alert-info mt-2 text-center">
                  <a href='/u/password/new' target="_blank" rel="noopener noreferrer">
                    Click here to reset your password
                  </a>
                </p>
              )}

              <div className="form-group">
                <label className="fw-bold custom-text-community">
                  {App.isBigSky ? "Zip Code" : "Street Address"}
                </label>
                <GooglePlacesAutocomplete
                  apiKey={App.googleApiKey}
                  placeholder="Please Enter Your Street Address"
                  selectProps={{
                    onChange: (place) => {
                      const description = place?.label;
                      if (!description) return;
                      this.setState({ homeAddress: description }, () => {
                        this.geocodeAddress(description);
                      });
                    },
                  }}
                />
              </div>

              <div className="form-group mt-2">
                <label
                  htmlFor="signup--phone"
                  className="fw-bold custom-text-community"
                  style={{ color: '#000000' }}
                >
                  Phone Number
                </label>
                <Input
                  placeholder="Please Enter Your Phone Number"
                  type="tel"
                  country="US"
                  international
                  withCountryCallingCode
                  maxLength={15}
                  className="form-control"
                  id="signup--phone"
                  name="phone"
                  value={phoneNumber}
                  onChange={(value) => this.setState({ phoneNumber: value })}
                  style={{
                    backgroundColor: '#ffffff',
                    color: '#000000',
                    border: '2px solid #2C2C2C',
                    borderRadius: '4px',
                    padding: '0.5rem',
                  }}
                />
              </div>

              <div className="mt-3 d-flex justify-content-end">
                <SmartButtonStub
                  text="Verify My Information"
                  buttonType="button"
                  className="primary custom-font-size custom-font-family mb-1 mb-md-0"
                  click={this.verifyHomeInfo}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="px-4 mt-3">
          <div className="d-flex flex-wrap">
            <div className="col-12 col-md-6 mb-4">
              <GuestSignupForm
                onSuccess={() => this.setState({ signupSuccess: true, activeForm: 'login' })}
                verificationError={verificationError}
                signupAddress={signupAddress}
                signupPhone={signupPhone}
                disableAddress={true}
              />
            </div>

            <div className="col-12 col-md-6 mb-4">
              <h6>Address Preview:</h6>
              <GoogleStaticMap
                address={signupAddress}
                defaultCenter={{ lat: homeLat, lng: homeLng }}
                defaultZoom={14}
              />
            </div>
          </div>
        </div>
      );
    }
  }

  geocodeAddress = async (address) => {
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address }, (results, status) => {
      if (status === "OK") {
        const location = results[0].geometry.location;
        this.setState({ homeLat: location.lat(), homeLng: location.lng()});
      } else {
        console.error("Geocoding failed:", status);
      }
    });
  };

  verifyHomeInfo = async () => {
    const { phoneNumber } = this.state;
    const addressVal = document.querySelector(".google-places-autocomplete__input")?.value
    this.geocodeAddress(addressVal);
    this.setState({
      homeAddress: addressVal,
    });

    if (!addressVal) {
      this.setState({
        verificationError: "Please enter address",
      });
      return;
    }

    if (!phoneNumber) {
      this.setState({
        verificationError: "Please enter Phone Number",
      });
      return;
    }

    const phoneObj = parsePhoneNumberFromString(phoneNumber, 'US');
    if (!phoneObj || !phoneObj.isValid() || phoneObj.country !== 'US' || phoneObj.getType() === 'UNKNOWN') {
      this.setState({
        verificationError: "Please enter a valid and real US phone number",
      });
      return;
    }

    this.setState({ verificationError: null });

    try {
      const res = await Backend.post("/users/verify_home", {
        address: addressVal,
        phone: phoneNumber,
      });

      const { addressExists, phoneExists, forgotPasswordLink } = res;

      if (addressExists && phoneExists) {
        this.setState({
          verificationError: `Please note, your account has already been created. If you need to reset your password, please do so at this link: `,
          userforgotPasswordLink: forgotPasswordLink,
          showRegisterHomeForm: false,
          showSignUpForm: false,
        });
      } else if (addressExists) {
        this.setState({
          verificationError: `Please note, your address has already been claimed. Your account will be added as a family profile account.`,
          userforgotPasswordLink: "",
          showSignUpForm: true,
          signupAddress: addressVal,
          signupPhone: phoneNumber,
        });
      } else {
        this.setState({
          verificationError: null,
          userforgotPasswordLink: "",
          showSignUpForm: true,
          signupAddress: addressVal,
          signupPhone: phoneNumber,
        });
      }
    } catch (err) {
      console.error(err);
      this.setState({
        verificationError:
          "Something went wrong while verifying. Please try again.",
      });
    }
  };

  logIn = async () => {
    const { email, password } = this.state;
    this.setState({ loginError: null });

    this.doLogin("/auth", {
      email,
      password,
      device_type: "browser",
    });
  };

  doLogin = async (url, params) => {
    try {
      let res = await Backend.post(url, params);
      console.info("auth as", res.user);
      User.signIn(res.user);
      this.setState({ loginError: null, userForgotPasswordLink: '' });
      window.location = "/app";
    } catch (xhr) {
      console.warn("auth failed", xhr);
      if (xhr.status >= 400 && xhr.status < 500) {
        const message = xhr.responseJSON.message;
        if (message === 'Please check your password and try again.') {
          this.setState({
            loginError: 'The password you entered is incorrect. If you need to reset your password, please do so at this link:',
            userForgotPasswordLink: '/u/password/new'
          });
          console.log("Setting forgot password link");
        } else {
          this.setState({
            loginError: message,
            userForgotPasswordLink: ''
          });
        }
      } else {
        this.setState({
          loginError: "Something went wrong. Please try again.",
        });
      }
    }
  };

  inputChanged = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
      error: null,
      loginError: null,
      verificationError: null,
    });
  };
}

export default withErrorBoundary(LoginPage);
